import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../auth/firebase";

/* ================= MOVIES ================= */
export const fetchEditorialMovies = async () => {
  try {
    const q = query(
      collection(db, "movies"),
      // where("editorialTag", "==", "watchitnow")
    );

    const snapshot = await getDocs(q);

    return snapshot.docs.map((doc) => {
      const data = doc.data();

      return {
        id: doc.id,
        ...data,
        title: data.title || data.name,
        poster_path: data.poster_path || data.posterUrl,
        overview: data.overview || "",
        type: "movie",
      };
    });
  } catch (error) {
    console.error("Firebase editorial movies error", error);
    return [];
  }
};

/* ================= WEB SERIES (SAME LOGIC) ================= */
export const fetchEditorialWebSeries = async () => {
  try {
    const q = query(
      collection(db, "webseries"),
      // where("editorialTag", "==", "watchitnow")
    );

    const snapshot = await getDocs(q);

    return snapshot.docs.map((doc) => {
      const data = doc.data();

      return {
        id: doc.id,
        ...data,
        title: data.title || data.name,
        poster_path: data.poster_path || data.posterUrl,
        overview: data.overview || "",
        type: "webseries",
      };
    });
  } catch (error) {
    console.error("Firebase editorial webseries error", error);
    return [];
  }
};


/* ================= Latest buzz (SAME LOGIC) ================= */
export const fetchLatestBuzz = async (limit = 12) => {
  try {
    const q = query(
      collection(db, "latestBuzz"),
      //orderBy("publishedAt", "desc")
    );

    const snapshot = await getDocs(q);

    return snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .slice(0, limit);
  } catch (err) {
    console.error("LatestBuzz fetch error", err);
    return [];
  }
};
